import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function PsfContentReducer(state = initialState.psfContent, action: any) {
  switch (action.type) {
    case types.SAVE_PSFCONTENT_SUCCESS:
      return action.psfContent;
    default:
      return state;
  }
}
